import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/pages/Dashboard.vue"),
      },
      {
        path: "user",
        name: "User Profile",
        component: () => import("@/pages/UserProfile.vue"),
      },
      {
        path: "findedituser",
        name: "User Editor",
        component: () => import("@/pages/FindEditUser.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "shorturl",
        name: "URL Shortener",
        component: () => import("@/pages/ShortUrl.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "streams",
        name: "Streams",
        component: () => import("@/pages/Streams.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "encode_cluster",
        name: "Encode Cluster",
        component: () => import("@/pages/EncodeCluster.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "streaming_cluster",
        name: "Streaming Cluster",
        component: () => import("@/pages/StreamingCluster.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "quickshare",
        name: "Quick Share",
        component: () => import("@/pages/QuickShare.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "/stream/:stream_id",
        name: "Stream",
        component: () => import("@/pages/Stream.vue"),
        meta: { requiresAdmin: true },
      },
      {
        // Stream2 was merged into Stream.vue in commit 840c066. Keep this
        // redirect so users with /stream2/... bookmarked or open in a tab
        // land on the consolidated page instead of a blank route.
        path: "/stream2/:stream_id",
        redirect: (to) => ({
          name: "Stream",
          params: { stream_id: to.params.stream_id },
          query: to.query,
        }),
      },
      {
        path: "/stream/:stream_id/diagnostics",
        name: "Stream Diagnostics",
        component: () => import("@/pages/StreamDiagnostics.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "/broadcast-history/:stream_id",
        name: "Broadcast History Explorer",
        component: () => import("@/pages/BroadcastHistoryExplorer.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "platform-settings",
        name: "Platform Settings",
        component: () => import("@/pages/PlatformSettings.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "videos",
        name: "Videos",
        component: () => import("@/pages/Videos.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "/vod_asset/:asset_id",
        name: "VodAsset",
        component: () => import("@/pages/VodAsset.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "client-accounts",
        name: "Client Accounts",
        component: () => import("@/pages/ClientAccounts.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "/client_account/:id",
        name: "Client Account",
        component: () => import("@/pages/ClientAccount.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "admin-docs/assistant",
        name: "AI Assistant",
        component: () => import("@/pages/AdminAssistant.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "admin-docs/docs",
        name: "Documentation",
        component: () => import("@/pages/AdminDocumentation.vue"),
        meta: { requiresAdmin: true },
      },
    ],
  },
];

export default routes;
